import { Base, Response } from '@.api/methods';

import { BrandListResponse, BrandResponseType, BrandsType, GetBrandPreviewProductsArchive, GetBrandPreviewProductsRestore } from './types';

export class BrandsApi extends Base {
    public getAll(query?: { page?: number; per_page?: number; search?: string; is_archived?: boolean; has_image?: boolean }) {
        this.setPath('brands');

        if (query) {
            this.setQuery(query);
        }

        return this.getRequest() as Response<BrandListResponse>;
    }

    public getById(id: number) {
        this.setPath('brands');
        this.setId(id);

        return this.getRequest() as Response<BrandResponseType>;
    }

    public create(data: BrandsType) {
        this.setPath('brands');
        this.setData(data);

        return this.postRequest();
    }

    /**
     * Full delete
     */
    public delete(id: number) {
        this.setPath('brands');
        this.setId(id);

        return this.deleteRequest();
    }

    public update(data: BrandsType, id: number) {
        this.setPath('brands');
        this.setId(id);
        this.setData(data);

        return this.putRequest();
    }

    public restore(brandId: number, archiveWithProducts: boolean) {
        this.setPath(`brands/${brandId}/restore`);

        this.setData({
            with_products: archiveWithProducts,
        });

        return this.postRequest();
    }

    public archive(brandId: number | string, archiveWithProducts: boolean) {
        this.setPath(`brands/${brandId}/archive`);

        this.setData({
            with_products: archiveWithProducts,
        });

        return this.postRequest();
    }

    public getArchivePreviewProducts(brandId: number | string) {
        this.setPath(`brands/${brandId}/archive`);

        return this.getRequest() as Response<GetBrandPreviewProductsArchive>;
    }

    public getRestorePreviewProducts(brandId: number | string) {
        this.setPath(`brands/${brandId}/restore`);

        return this.getRequest() as Response<GetBrandPreviewProductsRestore>;
    }
}
